import { reqConfig as req } from './request.config'
import { api } from './api.config'

export const apiConfig = api
export const request = req

export default {
  apiConfig: api,
  request: req
}
